export default __webpack_public_path__ + "static/media/bollywood_music.cf7c0671.jpg";